import { Customer } from "@Dao/index";
import {
  CustomerFailure,
  CustomerRequest,
  CustomerSuccess,
} from "@State/actions/actionCreators";
import { Dispatch } from "redux";
import getAPI from "@API/index";

export function loadCustomer(customerId: string) {
  return async (dispatch: Dispatch): Promise<void> => {
    dispatch(CustomerRequest());
    try {
      const response: Customer = await getAPI().request({
        url: `/api/Customer/${customerId}`,
      });
      dispatch(CustomerSuccess(response));
    } catch (e) {
      console.error("[loadCustomer]", e);
      dispatch(CustomerFailure());
    }
  };
}
